"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { ECOM_PROCESS_ILLUSTRATIONS } from "./ecom-process-illustrations";

/** Client wrapper: illustration components can't be passed from the server view. */
export function CcEcomProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return (
    <div id="ecom-process">
      <CcSeoProcess copy={copy} illustrations={ECOM_PROCESS_ILLUSTRATIONS} />
    </div>
  );
}
